const initialState = {
  fetchingFeed: false,
  feedData: {},
  fetchingFeedError: null,
};

export default function feed(state = initialState, action) {
  switch (action.type) {
    case "FETCH_FEED_REQUESTED":
      return {
        ...state,
        fetchingFeed: true,
        feedData: {},
        fetchingFeedError: null,
      };
    case "FETCH_FEED_SUCCESS":
      return {
        ...state,
        fetchingFeed: false,
        feedData: action.payload,
        fetchingFeedError: null,
      };
    case "FETCH_FEED_FAILED":
      return {
        ...state,
        fetchingFeed: false,
        feedData: {},
        fetchingFeedError: action.payload,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/feed.reducer.js